import { CountryCode } from '../../i18n/countryCodes'
import authorize from './authorize'
import fetchUser from './fetchUser'
import updatePassword from './updatePassword'

export { authorize, fetchUser, updatePassword }

export enum UserStatus {
  Inactive = 0,
  Active = 1,
}

export enum CalendarMode {
  Days19View = 1,
  MonthView = 2,
}

export interface IUser {
  id?: number
  email?: string
  savedLanguage?: CountryCode
  createDate?: Date
  newUserDate?: Date
  serverTime?: Date
  userTime?: Date
  userOffset?: number
  promotionUsed?: number
  booking_property_id?: string
  booking_integration_status?: string
  userPriceGroup: any
  booking_currency?: string
  scopes?: string[]
  id_owner?: string
  id_worker?: string
  owner_email?: string
  debug_mode?: boolean
  poll_displayed: boolean
  cookies_information: boolean
  reservation_form_settings?: Record<string, boolean>
  reservation_form_banner?: number
}

export interface IUserDateTimeFormat {
  dateFormat?: string
  timeFormat?: string
  createDate?: Date
}
